<!-- eslint-disable vue/no-v-html -->
<template>
  <span
    v-if="translatedAndRenderedHtml"
    v-html="translatedAndRenderedHtml"
    class="markdown-content"
    data-testid="markdown-content"
  />
</template>

<script setup>
import DOMPurify from 'dompurify';
import { marked } from 'marked';

const $bct = inject('translator');

const addTargetAndRelToLinks = (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'nofollow');
  }
  return node;
};
DOMPurify.addHook('afterSanitizeAttributes', addTargetAndRelToLinks);

const props = defineProps({
  content: {
    type: String,
    default: null,
  },
  noTranslate: {
    type: Boolean,
    default: false,
  },
});

const translatedAndRenderedHtml = computed(() => {
  if (!props.content) return null;
  const html = renderMarkdown(props.noTranslate ? props.content : $bct(props.content));
  return DOMPurify.sanitize(html);
});

function renderMarkdown(string) {
  if (!string) return null;

  const renderer = new marked.Renderer();

  renderer.paragraph = function (text) {
    return `${text}`;
  };
  return marked(string, { renderer });
}
</script>

<style>
.markdown-content > ol,
ul {
  list-style-position: inside;
}
</style>
